import { useEffect } from 'react';
import JersuFoto from '../../assets/img/grupos/FOTO JERSU - SITE 01 (1).png';

const styles = `
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent
}

#lp {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "SF Pro Display", system-ui, "Helvetica Neue", Arial, sans-serif;
  color: #e9edef;
  background: linear-gradient(180deg,#0b141a,#111b21);
  min-height: 100dvh;
  overflow-x: hidden;
  position: relative;
  line-height: 1.4;
  -webkit-font-smoothing: antialiased;
  padding-bottom: calc(60px + env(safe-area-inset-bottom) + 28px)
}

#lp .orbs {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden
}

#lp .orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: .5;
  animation: float 14s ease-in-out infinite
}

#lp .orb.g {
  width: 280px;
  height: 280px;
  background: radial-gradient(circle,#25d366,transparent 70%);
  top: -60px;
  right: -60px
}

#lp .orb.b {
  width: 320px;
  height: 320px;
  background: radial-gradient(circle,#00a884,transparent 70%);
  bottom: -100px;
  left: -80px;
  animation-delay: -5s
}

@keyframes float {
  0%,100% { transform: translate(0,0) }
  50% { transform: translate(20px,30px) }
}

#lp .wrap {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: 0 18px
}

#lp .livebar {
  position: relative;
  z-index: 3;
  text-align: center;
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: .4px;
  line-height: 1.3;
  text-transform: uppercase;
  color: #fff;
  background: linear-gradient(90deg,#ff2233,#e10f22);
  border-bottom: 1px solid rgba(255,255,255,.14);
  box-shadow: 0 4px 22px rgba(255,25,45,.4);
  animation: liveGlow 2s ease-in-out infinite
}

@keyframes liveGlow {
  50% { box-shadow: 0 4px 30px rgba(255,25,45,.7) }
}

#lp .livebar b { color: #fff }

#lp .hero {
  position: relative;
  z-index: 2;
  min-height: calc(100dvh - 72px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px 0;
  gap: clamp(17px,4.5vw,26px)
}

#lp h1 {
  font-size: min(6.8vw,2.2rem);
  font-weight: 900;
  line-height: 1.12;
  letter-spacing: -.5px
}

#lp h1 .hl-line {
  display: block;
  white-space: nowrap
}

#lp h1 .hl {
  background: linear-gradient(90deg,#25d366,#00e676);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent
}

#lp .subhead {
  font-size: clamp(1rem,4.4vw,1.2rem);
  font-weight: 600;
  color: #8696a0
}

#lp .subhead b { color: #e9edef }

#lp .hero-media {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center
}

#lp .ring {
  position: absolute;
  width: 114%;
  height: 114%;
  border-radius: 50%;
  background: conic-gradient(from 0deg,#25d366,#00a884,#25d366);
  filter: blur(14px);
  opacity: .55;
  animation: spin 8s linear infinite
}

@keyframes spin {
  to { transform: rotate(360deg) }
}

#lp .hero-img {
  position: relative;
  z-index: 2;
  width: clamp(180px,52vw,248px);
  height: clamp(180px,52vw,248px);
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid rgba(37,211,102,.5);
  box-shadow: 0 18px 50px rgba(0,0,0,.6),0 0 0 6px rgba(37,211,102,.1)
}

#lp .cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  max-width: 420px;
  min-height: 60px;
  padding: 0 18px;
  border-radius: 16px;
  font-size: 1.18rem;
  font-weight: 900;
  letter-spacing: .4px;
  text-transform: uppercase;
  color: #04130c;
  text-decoration: none;
  background: linear-gradient(100deg,#25d366,#00a884);
  box-shadow: 0 12px 34px rgba(37,211,102,.4);
  position: relative;
  overflow: hidden;
  border: none;
  cursor: pointer
}

#lp #ctaHero {
  animation: ctaIn 1.6s cubic-bezier(.2,.8,.2,1) .6s both, breathe 2.6s ease-in-out 2.3s infinite
}

@keyframes ctaIn {
  0% { opacity: 0; transform: translateY(20px) scale(.94) }
  60% { opacity: 1 }
  100% { opacity: 1; transform: none }
}

@keyframes breathe {
  0%,100% { transform: scale(1) }
  50% { transform: scale(1.025) }
}

#lp .cta::after {
  content: "";
  position: absolute;
  top: 0;
  left: -120%;
  width: 60%;
  height: 100%;
  background: linear-gradient(100deg,transparent,rgba(255,255,255,.55),transparent);
  transform: skewX(-20deg);
  animation: shine 3.2s ease-in-out infinite
}

@keyframes shine {
  0% { left: -120% }
  55%,100% { left: 160% }
}

#lp .cta:active { transform: scale(.97) }

#lp .cta .ic-wpp {
  width: 1.5em;
  height: 1.5em;
  fill: currentColor;
  flex: 0 0 auto;
  display: inline-block
}

#lp .seals {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  justify-content: center;
  font-size: 13px;
  color: #8696a0;
  font-weight: 700
}

#lp .seals .ck { color: #25d366 }

#lp .scroll-hint {
  font-size: 11px;
  color: #8696a0;
  letter-spacing: 1px;
  opacity: .7;
  animation: bob 1.6s ease-in-out infinite
}

@keyframes bob {
  50% { transform: translateY(4px) }
}

#lp section {
  position: relative;
  z-index: 2;
  padding: 40px 0 8px
}

#lp .eyebrow {
  display: inline-block;
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #25d366;
  margin-bottom: 10px
}

#lp h2 {
  font-size: clamp(1.5rem,6vw,2rem);
  font-weight: 900;
  letter-spacing: -.5px;
  line-height: 1.12;
  margin-bottom: 20px
}

#lp .stack {
  display: flex;
  flex-direction: column;
  gap: 13px
}

#lp .card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  border-radius: 18px;
  background: #1f2c33;
  border: 1px solid rgba(255,255,255,.08);
  box-shadow: 0 8px 30px rgba(0,0,0,.3)
}

#lp .card .cico {
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  background: rgba(37,211,102,.16);
  border: 1px solid rgba(37,211,102,.3)
}

#lp .card h3 {
  font-size: 1.05rem;
  font-weight: 800;
  margin-bottom: 2px
}

#lp .card p {
  font-size: .86rem;
  color: #8696a0;
  line-height: 1.35
}

#lp .proof { text-align: center }

#lp .stats {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 18px
}

#lp .stat {
  flex: 1;
  min-width: 140px;
  padding: 20px 14px;
  border-radius: 18px;
  background: linear-gradient(160deg,rgba(37,211,102,.12),rgba(0,168,132,.07));
  border: 1px solid rgba(255,255,255,.08)
}

#lp .stat .num {
  font-size: clamp(1.7rem,8vw,2.4rem);
  font-weight: 900;
  line-height: 1;
  letter-spacing: -1px;
  background: linear-gradient(90deg,#25d366,#00e676);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent
}

#lp .stat .lbl {
  font-size: .78rem;
  color: #8696a0;
  font-weight: 600;
  margin-top: 6px;
  text-transform: uppercase;
  letter-spacing: .5px
}

#lp .stars {
  color: #ffd24a;
  font-size: 1.05rem;
  letter-spacing: 3px
}

#lp .proof small {
  display: block;
  color: #8696a0;
  font-size: .82rem;
  margin-top: 8px
}

#lp .final { text-align: center }

#lp .final-box {
  padding: 30px 20px;
  border-radius: 26px;
  background: radial-gradient(100% 100% at 50% 0%,rgba(37,211,102,.16),transparent 60%),#1f2c33;
  border: 1px solid rgba(37,211,102,.3);
  box-shadow: 0 0 50px rgba(37,211,102,.14)
}

#lp .final-box h2 { margin-bottom: 8px }

#lp .final-box p {
  color: #8696a0;
  font-size: .95rem;
  margin-bottom: 20px
}

#lp .final .cta { margin: 0 auto }

#lp .final .micro {
  font-size: 11.5px;
  color: #8696a0;
  margin-top: 12px
}

#lp footer {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 28px 18px 10px;
  font-size: 11px;
  color: #8696a0;
  opacity: .7;
  line-height: 1.6
}

#lp .rv {
  opacity: 0;
  transform: translateY(16px);
  animation: rise .7s cubic-bezier(.2,.8,.2,1) forwards
}

@keyframes rise {
  to { opacity: 1; transform: none }
}

#lp .d1 { animation-delay: .05s }
#lp .d2 { animation-delay: .15s }
#lp .d3 { animation-delay: .25s }
#lp .d4 { animation-delay: .35s }
#lp .d5 { animation-delay: .45s }
#lp .d6 { animation-delay: .55s }

@media (prefers-reduced-motion:reduce) {
  #lp .rv,#lp .cta,#lp .orb,#lp .ring,#lp .livebar,#lp .cta::after {
    animation: none!important;
    opacity: 1!important;
    transform: none!important
  }
}

@media(min-width: 760px) {
  #lp .wrap { max-width: 960px; padding: 0 32px }
  #lp .hero {
    min-height: auto;
    padding: 48px 0 30px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    gap: 16px 40px;
    text-align: left;
    max-width: 960px;
    margin: 0 auto
  }
  #lp .hero-media { grid-column: 2; grid-row: 1 / span 5; justify-self: center }
  #lp .hero h1 { grid-column: 1; text-align: left; font-size: 2.7rem }
  #lp .hero .subhead { grid-column: 1; text-align: left }
  #lp .hero .cta { grid-column: 1; max-width: 360px }
  #lp .hero .seals { grid-column: 1; justify-content: flex-start }
  #lp h1 .hl-line { white-space: normal }
  #lp .scroll-hint { display: none }
  #lp .hero-img { width: 330px; height: 330px }
  #lp .stack { display: grid; grid-template-columns: 1fr 1fr; gap: 16px }
  #lp section { padding: 56px 0 10px; max-width: 960px; margin: 0 auto }
}

#lp .sticky {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
  padding: 10px 14px calc(10px + env(safe-area-inset-bottom));
  background: linear-gradient(0deg,#0b141a 72%,transparent);
  display: flex;
  justify-content: center;
  transform: translateY(120%);
  transition: transform .35s cubic-bezier(.2,.8,.2,1)
}

#lp .sticky.show { transform: translateY(0) }

#lp .sticky .cta { max-width: 460px }

@media(max-width: 759px) {
  #lp .hero { justify-content: flex-start; padding-top: 20px; padding-bottom: 30px }
  #lp .hero h1 { margin-top: auto }
  #lp #ctaHero { margin-top: auto }
}

#lp { padding-bottom: calc(env(safe-area-inset-bottom) + 26px) }

body { padding-top: 0 !important; }

@media(min-width: 760px) {
  #lp .sticky { display: none }
}
`;

export default function GrupoNoWhats() {
  useEffect(() => {
    const s = document.getElementById('sticky');
    const h = document.getElementById('ctaHero');
    if (!s || !h) return;
    const io = new IntersectionObserver((es) => {
      es.forEach((e) => {
        if (e.isIntersecting) s.classList.remove('show');
        else s.classList.add('show');
      });
    }, { threshold: 0 });
    io.observe(h);
    return () => io.disconnect();
  }, []);

  return (
    <>
      <style>{styles}</style>
      <div id="lp">
        <div className="orbs">
          <div className="orb g" />
          <div className="orb b" />
        </div>
        <div className="livebar">
          <span>
            🎯 APROVEITE AGORA AS MELHORES PROMOÇÕES DE 2026
          </span>
        </div>
        <div className="wrap">
          <header className="hero">
            <h1 className="rv d2">
              <span className="hl-line">🚨 JERSU INDICA OFERTAS</span>
              <span className="hl-line">
                <span className="hl">100% GRATUITO</span>
                🚨
              </span>
            </h1>
            <div className="hero-media rv d3">
              <div className="ring" />
              <img
                className="hero-img"
                src={JersuFoto}
                alt="Jersu Indica"
              />
            </div>
            <p className="subhead rv d4">
              Produtos pela <b>METADE DO PREÇO</b> ⚡
            </p>
            <a
              className="cta rv d4"
              href="https://jersu.com.br/redirecionar?tipo=trafego"
              id="ctaHero"
            >
              <svg className="ic-wpp" viewBox="0 0 32 32" aria-hidden="true">
                <path d="M16.04 4C9.93 4 4.97 8.96 4.97 15.07c0 2.13.6 4.13 1.64 5.84L4.6 28l7.27-1.9a11 11 0 0 0 4.17.82h.01c6.11 0 11.07-4.96 11.07-11.07C27.12 8.96 22.16 4 16.04 4zm0 20.27h-.01a9.2 9.2 0 0 1-4.69-1.28l-.34-.2-3.48.91.93-3.39-.22-.35a9.18 9.18 0 0 1-1.41-4.9c0-5.08 4.13-9.21 9.22-9.21 2.46 0 4.78.96 6.52 2.7a9.16 9.16 0 0 1 2.7 6.52c0 5.09-4.14 9.21-9.22 9.21zm5.05-6.9c-.28-.14-1.64-.81-1.89-.9-.25-.09-.43-.14-.62.14-.18.28-.71.9-.87 1.08-.16.18-.32.2-.6.07-.28-.14-1.17-.43-2.23-1.38-.82-.74-1.38-1.65-1.54-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.49.14-.16.18-.28.28-.46.09-.18.05-.35-.02-.49-.07-.14-.62-1.5-.85-2.05-.22-.54-.45-.47-.62-.48l-.53-.01c-.18 0-.48.07-.73.35-.25.28-.96.94-.96 2.3 0 1.36.99 2.67 1.12 2.85.14.18 1.94 2.96 4.7 4.15.66.28 1.17.45 1.57.58.66.21 1.26.18 1.74.11.53-.08 1.64-.67 1.87-1.32.23-.65.23-1.2.16-1.32-.07-.12-.25-.19-.53-.33z"/>
              </svg>
              ENTRAR NO GRUPO
            </a>
            <div className="seals rv d5">
              <span>
                <span className="ck">✓</span>
                JÁ SOMOS +200 MIL MEMBROS
              </span>
            </div>
            <div className="scroll-hint rv d6">▼ veja o que você recebe</div>
          </header>
          <section className="benefits">
            <span className="eyebrow">O que você recebe</span>
            <h2>
              Tudo o que precisa pra<br />nunca mais pagar caro.
            </h2>
            <div className="stack">
              <div className="card">
                <div className="cico">🛰️</div>
                <div>
                  <h3>Promoções monitoradas 24h</h3>
                  <p>Eu rastreio todas as lojas dia e noite pra você.</p>
                </div>
              </div>
              <div className="card">
                <div className="cico">🎟️</div>
                <div>
                  <h3>Cupons exclusivos</h3>
                  <p>Descontos que não aparecem em nenhum outro lugar.</p>
                </div>
              </div>
              <div className="card">
                <div className="cico">⚡</div>
                <div>
                  <h3>Ofertas relâmpago</h3>
                  <p>Aviso antes de acabar — você compra primeiro.</p>
                </div>
              </div>
              <div className="card">
                <div className="cico">✅</div>
                <div>
                  <h3>Só promoções de verdade</h3>
                  <p>Só o que realmente está valendo muito a pena.</p>
                </div>
              </div>
            </div>
          </section>
          <section className="proof">
            <span className="eyebrow">Junte-se à comunidade</span>
            <div className="stats">
              <div className="stat">
                <div className="num">+200 MIL</div>
                <div className="lbl">Membros ativos</div>
              </div>
              <div className="stat">
                <div className="num">+100</div>
                <div className="lbl">Ofertas por dia</div>
              </div>
            </div>
            <div className="stars">★★★★★</div>
            <small>Mais de 200 mil pessoas já economizam todo dia.</small>
          </section>
          <section className="final">
            <div className="final-box">
              <h2>
                Sua próxima compra<br />pode sair pela metade.
              </h2>
              <p>Entrada gratuita. Vagas limitadas.</p>
              <a
                className="cta"
                href="https://jersu.com.br/redirecionar?tipo=trafego"
              >
                <svg className="ic-wpp" viewBox="0 0 32 32" aria-hidden="true">
                  <path d="M16.04 4C9.93 4 4.97 8.96 4.97 15.07c0 2.13.6 4.13 1.64 5.84L4.6 28l7.27-1.9a11 11 0 0 0 4.17.82h.01c6.11 0 11.07-4.96 11.07-11.07C27.12 8.96 22.16 4 16.04 4zm0 20.27h-.01a9.2 9.2 0 0 1-4.69-1.28l-.34-.2-3.48.91.93-3.39-.22-.35a9.18 9.18 0 0 1-1.41-4.9c0-5.08 4.13-9.21 9.22-9.21 2.46 0 4.78.96 6.52 2.7a9.16 9.16 0 0 1 2.7 6.52c0 5.09-4.14 9.21-9.22 9.21zm5.05-6.9c-.28-.14-1.64-.81-1.89-.9-.25-.09-.43-.14-.62.14-.18.28-.71.9-.87 1.08-.16.18-.32.2-.6.07-.28-.14-1.17-.43-2.23-1.38-.82-.74-1.38-1.65-1.54-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.49.14-.16.18-.28.28-.46.09-.18.05-.35-.02-.49-.07-.14-.62-1.5-.85-2.05-.22-.54-.45-.47-.62-.48l-.53-.01c-.18 0-.48.07-.73.35-.25.28-.96.94-.96 2.3 0 1.36.99 2.67 1.12 2.85.14.18 1.94 2.96 4.7 4.15.66.28 1.17.45 1.57.58.66.21 1.26.18 1.74.11.53-.08 1.64-.67 1.87-1.32.23-.65.23-1.2.16-1.32-.07-.12-.25-.19-.53-.33z"/>
                </svg>
                ENTRAR NO GRUPO AGORA
              </a>
              <div className="micro">🔒 Grupo oficial · Sem custo</div>
            </div>
          </section>
          <footer>
            Este grupo envia apenas ofertas e cupons. Você pode sair a qualquer momento.<br />© Jersu Indica Ofertas — todos os direitos reservados.
          </footer>
        </div>
        <div className="sticky" id="sticky">
          <a
            className="cta"
            href="https://jersu.com.br/redirecionar?tipo=trafego"
          >
            <svg className="ic-wpp" viewBox="0 0 32 32" aria-hidden="true">
              <path d="M16.04 4C9.93 4 4.97 8.96 4.97 15.07c0 2.13.6 4.13 1.64 5.84L4.6 28l7.27-1.9a11 11 0 0 0 4.17.82h.01c6.11 0 11.07-4.96 11.07-11.07C27.12 8.96 22.16 4 16.04 4zm0 20.27h-.01a9.2 9.2 0 0 1-4.69-1.28l-.34-.2-3.48.91.93-3.39-.22-.35a9.18 9.18 0 0 1-1.41-4.9c0-5.08 4.13-9.21 9.22-9.21 2.46 0 4.78.96 6.52 2.7a9.16 9.16 0 0 1 2.7 6.52c0 5.09-4.14 9.21-9.22 9.21zm5.05-6.9c-.28-.14-1.64-.81-1.89-.9-.25-.09-.43-.14-.62.14-.18.28-.71.9-.87 1.08-.16.18-.32.2-.6.07-.28-.14-1.17-.43-2.23-1.38-.82-.74-1.38-1.65-1.54-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.49.14-.16.18-.28.28-.46.09-.18.05-.35-.02-.49-.07-.14-.62-1.5-.85-2.05-.22-.54-.45-.47-.62-.48l-.53-.01c-.18 0-.48.07-.73.35-.25.28-.96.94-.96 2.3 0 1.36.99 2.67 1.12 2.85.14.18 1.94 2.96 4.7 4.15.66.28 1.17.45 1.57.58.66.21 1.26.18 1.74.11.53-.08 1.64-.67 1.87-1.32.23-.65.23-1.2.16-1.32-.07-.12-.25-.19-.53-.33z"/>
            </svg>
            ENTRAR NO GRUPO
          </a>
        </div>
      </div>
    </>
  );
}
